import { FieldDecorator } from '@snack-uikit/fields';
import { Radio } from '@snack-uikit/toggles';
import cn from 'classnames';
import { useId } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FieldProps } from './FieldProps';
import s from './ParticipationFormat.module.scss';

const FIELD_NAME = 'participationFormat';

const REQUIRED_ERR = 'Выберите формат участия';

const OFFLINE = 'offline';
const ONLINE = 'online';

export function ParticipationFormat(props: FieldProps) {
  const { className, isSendingStatus, sendFormFillAnalytics } = props;

  const offlineId = useId();
  const onlineId = useId();

  const { setValue } = useFormContext();

  return (
    <div className={cn(className)}>
      <Controller
        name={FIELD_NAME}
        rules={{ required: REQUIRED_ERR }}
        render={({ field, fieldState }) => (
          <FieldDecorator
            error={fieldState.error?.message?.toString()}
            label="В каком формате вы хотите принять участие:"
            size="m"
            disabled={isSendingStatus}
            required
          >
            <div className={s.fieldWrapper}>
              <label className={s.label} htmlFor={offlineId}>
                <Radio
                  {...field}
                  id={offlineId}
                  checked={field.value === OFFLINE}
                  disabled={isSendingStatus}
                  onChange={() => {
                    sendFormFillAnalytics(`Participation format: ${OFFLINE}`);
                    setValue(FIELD_NAME, OFFLINE);
                  }}
                />
                <span className={s.text}>Офлайн</span>
              </label>
              <label className={s.label} htmlFor={onlineId}>
                <Radio
                  {...field}
                  id={onlineId}
                  checked={field.value === ONLINE}
                  disabled={isSendingStatus}
                  onChange={() => {
                    sendFormFillAnalytics(`Participation format: ${ONLINE}`);
                    setValue(FIELD_NAME, ONLINE);
                  }}
                />
                <span className={s.text}>Онлайн</span>
              </label>
            </div>
          </FieldDecorator>
        )}
      />
    </div>
  );
}
